import { FC } from 'react';
import { Document, Image, Page, Text, View } from '@react-pdf/renderer';

import { getLabelWidth } from './helpers';
import { EntityPdfData, EntityPdfField } from './types';

import { styles } from './styles';

type Props = {
  data: EntityPdfData;
};

const renderFields = (fields: EntityPdfField[]) => {
  const labelWidth = getLabelWidth(fields);

  return fields.map((field, index) => (
    <View key={index} style={styles.row}>
      {field.label && <Text style={[styles.label, { width: labelWidth }]}>{field.label}</Text>}
      <Text style={styles.value}>{field.value}</Text>
    </View>
  ));
};

export const EntityPDF: FC<Props> = ({ data }) => {
  return (
    <Document>
      <Page size={{ width: 895, height: 1244 }} style={styles.page}>
        {data.sections.map((section, sectionIndex) => (
          <View key={sectionIndex} style={styles.section}>
            <Text style={styles.sectionTitle}>{section.title}</Text>

            {section.fields && section.fields.length > 0 && (
              <View style={{ marginBottom: 10 }}>{renderFields(section.fields)}</View>
            )}

            {section.itemGroups?.map((group, groupIndex) => (
              <View key={groupIndex}>
                {group.title && (
                  <View style={styles.groupTitleContainer}>
                    <Text style={styles.groupTitle}>{group.title}</Text>
                    {group.count !== undefined && <Text style={styles.badge}>{group.count}</Text>}
                  </View>
                )}
                {group.items.map((item, itemIndex) => (
                  <View key={itemIndex} style={{ marginBottom: 15 }}>
                    {renderFields(item.fields)}
                  </View>
                ))}
              </View>
            ))}
          </View>
        ))}
      </Page>
      {Boolean(data.attachments?.length) && (
        <Page size={{ width: 895, height: 1244 }} style={styles.page}>
          <Text style={styles.sectionTitle}>Attached Files</Text>
          {data.attachments!.map((attachment, index) => (
            <Image src={attachment} key={index} />
          ))}
        </Page>
      )}
    </Document>
  );
};
